import { ApplicationConfig } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideCoreConfig } from '@spike/core';
import { routeConfig } from './config/app.routes.config';
import { Theme } from './config/app.theme';
import { keycloakConfig, baseUrl } from './../environments/environment';


export const appConfig: ApplicationConfig = {
    providers: [
      ConfirmationService,
      provideCoreConfig(keycloakConfig, routeConfig, baseUrl),
      providePrimeNG({
            theme: {
                preset: Theme,
                options: {
                    darkModeSelector: '.app-dark' // o 'system'
                }
            }
        }),
      provideAnimationsAsync(),
    ]
};
